export default __webpack_public_path__ + "camera.svg";